import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AllFiles from './components/AllFiles';
import ChatBot from './components/ChatBot';
import PrivateRoute from './SecurityConfig/PrivateRoute';
import AuthContextProvider from './SecurityConfig/AuthContextProvider';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import AuthForm from './components/AuthForm';
import MyFiles from './components/MyFiles';
import Pagenotfound from '../components/views/PageNotFound';
import BeginnerGuide from './components/Aichatbotlanding';

function Guntechchat() {
  return (
    <div className="">
      {/* <SendOtp/> */}
      {/* <SignIn/> */}
      {/* <FileUI/> */}
      <DndProvider backend={HTML5Backend}>
        <AuthContextProvider>
          <Routes>
            {/* <Route path = '/' element= {<SendOtp/>}/> */}
            <Route path="/chatbotbase">
              <Route path="" element={<BeginnerGuide />} />
              <Route path="*" element={<Pagenotfound />} />
              <Route path="signin" element={<AuthForm />} />
              <Route
                path="allfiles"
                element={
                  <PrivateRoute>
                    <AllFiles />
                  </PrivateRoute>
                }
              />

              <Route
                path="chatbot"
                element={
                  <PrivateRoute>
                    <ChatBot />
                  </PrivateRoute>
                }
              />
              <Route
                path="myfiles"
                element={
                  <PrivateRoute>
                    <MyFiles />
                  </PrivateRoute>
                }
              />
            </Route>
          </Routes>
        </AuthContextProvider>
      </DndProvider>
    </div>
  );
}

export default Guntechchat;
